import HeroBanner from "../../components/HeroBanner";
import HomeAbout from "../../components/HomeAbout";
import WhySection from "../../components/WhySection";
import Feedback from "../../components/Feedback";

const Home = () => {
  return (
    <div>
      <HeroBanner />
      <HomeAbout />
      <WhySection />
      <Feedback />
    </div>
  );
};

export default Home;
